import { createSelector } from 'reselect';

export const selectExistantClaimsState = (state: any) =>
  state.get('existantClaims');

export const makeSelectExistantClaims = () =>
  createSelector(selectExistantClaimsState, (documents: any) => {
    if (documents && documents.get('existantClaims')) {
      return documents.get('existantClaims').toJS();
    }
    return [];
  });
